import React from 'react';
import { graphql, useStaticQuery, Link } from 'gatsby';

import Wrapper from 'components/Layout/Wrapper';
import Logo from 'components/Layout/Logo';
import { Text } from 'components/UI';

import styles from './footer.module.scss';

const Footer = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          author
          title
          email
        }
      }
      allContactsJson {
        edges {
          node {
            city
            address
          }
        }
      }
    }
  `);

  interface IContactEdge {
    node: { city: string; address: string; }
  }

  const {
    site: { siteMetadata: { title, author, email } },
    allContactsJson: { edges: contacts },
  } = data;

  return (
    <footer className={styles.footer}>
      <Wrapper className={styles.wrapper}>
        <Logo className={styles.logo} title={title} />
        <div className={styles.cols}>
          <div className={styles.col}>
            <div className={styles.nav}>
              <Link className={styles.navLink} to="/disclaimer">Disclaimer</Link>
              <Link className={styles.navLink} to="/privacy-policy">Privacy Policy</Link>
              <Link className={styles.navLink} to="/privacy-policy#california">California Privacy Notice</Link>
            </div>
            <div className={styles.email}>
              <a className={styles.emailLink} href={`mailto:${email}`}>{email}</a>
            </div>
          </div>
          <div className={styles.col}>
            <ul className={styles.contacts}>
              {contacts.map(({ node: { city, address } }: IContactEdge) => (
                <li key={city} className={styles.contact}>
                  <span className={styles.contactCity}>{city}</span>
                  <span className={styles.contactAddress}>{address}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <Text className={styles.copyright}>
          {`Copyright ©2020 ${author}`}
        </Text>
      </Wrapper>
    </footer>
  );
};

export default Footer;
